import React from 'react';
import './theme.css';

const Card = ({ name, shortDescription, codeUrl, techStack, awards, devpost }) => {
  return (
    <div style={styles.card}>
      <div style={styles.content}>
        <h3 style={styles.title}>{name}</h3>
        <p style={styles.description}>{shortDescription}</p>
        <div style={styles.techStackContainer}>
          <span style={styles.techStackLabel}>Tech Stack:</span>
          <div style={styles.techStackTags}>
            {techStack.split(',').map((tech, index) => (
              <span key={index} style={styles.techTag}>
                {tech.trim()}
              </span>
            ))}
          </div>
        </div>
        {awards && (
          <div style={styles.awardsContainer}>
            <span style={styles.awardsLabel}>Awards:</span>
            <p style={styles.awards}>{awards}</p>
          </div>
        )}
      </div>
      <div style={styles.linksContainer}>
        {codeUrl && (
          <a
            href={codeUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            <span style={styles.linkIcon}>📂</span>
            GitHub
          </a>
        )}
        {devpost && (
          <a
            href={devpost}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            <span style={styles.linkIcon}>🏆</span>
            Devpost
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  card: {
    border: '1px solid var(--card-border)',
    borderRadius: '16px',
    padding: '2rem',
    backgroundColor: 'var(--card-bg)',
    boxShadow: '0 4px 6px var(--header-shadow)',
    transition: 'all 0.3s ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    height: '100%',
    ':hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 24px var(--header-shadow)',
    },
  },
  content: {
    flex: 1,
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: 'var(--gray-900)',
    marginBottom: '1rem',
  },
  description: {
    fontSize: '1rem',
    color: 'var(--gray-600)',
    lineHeight: '1.6',
    marginBottom: '1.5rem',
  },
  techStackContainer: {
    marginBottom: '1.5rem',
  },
  techStackLabel: {
    display: 'block',
    fontSize: '0.875rem',
    color: 'var(--gray-500)',
    marginBottom: '0.5rem',
    fontWeight: '500',
  },
  techStackTags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
  },
  techTag: {
    padding: '0.25rem 0.75rem',
    backgroundColor: 'var(--gray-100)',
    color: 'var(--gray-700)',
    borderRadius: '9999px',
    fontSize: '0.875rem',
    fontWeight: '500',
  },
  awardsContainer: {
    marginBottom: '1.5rem',
  },
  awardsLabel: {
    display: 'block',
    fontSize: '0.875rem',
    color: 'var(--gray-500)',
    marginBottom: '0.5rem',
    fontWeight: '500',
  },
  awards: {
    fontSize: '0.875rem',
    color: 'var(--gray-700)',
    lineHeight: '1.5',
  },
  linksContainer: {
    display: 'flex',
    gap: '1rem',
    marginTop: 'auto',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.75rem 1.25rem',
    backgroundColor: 'var(--card-border)',
    color: 'var(--text-color)',
    borderRadius: '8px',
    textDecoration: 'none',
    fontSize: '0.875rem',
    fontWeight: '500',
    transition: 'all 0.2s ease-in-out',
    ':hover': {
      backgroundColor: 'var(--header-shadow)',
      color: 'var(--primary-color)',
    },
  },
  linkIcon: {
    fontSize: '1rem',
  },
};

export default Card;
